//select-files.ts
import { writable } from "svelte/store";
function createFileListStore() {
    const { subscribe, update } = writable({
        selectedFiles: [],
        minDate: "9999-12-31",
        maxDate: "0001-01-01",
        stations: new Set(),
        datatypes: new Set()
    });
    return {
        subscribe,
        add: (f) => update((state) => {
            var _a, _b;
            state.selectedFiles.push(f);
            (_a = f.stations) === null || _a === void 0 ? void 0 : _a.forEach((tuple) => {
                state.stations.add(tuple);
            });
            (_b = f.dataTypes) === null || _b === void 0 ? void 0 : _b.forEach((tuple) => {
                state.datatypes.add(tuple);
            });
            return Object.assign(Object.assign({}, state), { selectedFiles: [...state.selectedFiles], minDate: (f === null || f === void 0 ? void 0 : f.startDate) < state.minDate ? f.startDate : state.minDate, maxDate: (f === null || f === void 0 ? void 0 : f.endDate) > state.maxDate ? f.endDate : state.maxDate, stations: new Set(state.stations), datatypes: new Set(state.datatypes) });
        }),
        remove: (file) => update((state) => {
            const acc = {
                selectedFiles: [],
                maxDate: "0001-01-01",
                minDate: "9999-12-31",
                stations: new Set(),
                datatypes: new Set()
            };
            state.selectedFiles
                .filter((f) => f.id !== file.id)
                .forEach((file) => {
                var _a;
                acc.selectedFiles.push(file);
                acc.maxDate = file.endDate > acc.maxDate ? file.endDate : acc.maxDate;
                acc.minDate = file.startDate < acc.minDate ? file.startDate : acc.minDate;
                file.stations.forEach((tuple) => {
                    acc.stations.add(tuple);
                });
                (_a = file.dataTypes) === null || _a === void 0 ? void 0 : _a.forEach((tuple) => {
                    acc.datatypes.add(tuple);
                });
            });
            return acc;
        }),
        removeAll: () => update((state) => {
            return {
                selectedFiles: [],
                minDate: "9999-12-31",
                maxDate: "0001-01-01",
                stations: new Set(),
                datatypes: new Set()
            };
        })
    };
}
export const fileStore = createFileListStore();
